
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model'
import store from '@/store';

@Options({})
export default class copyableModal extends Vue {

    @Prop() text: string;
    @Prop({
        default: 'OK'
    }) okText: string;
    @Prop() okCallback: () => Promise<any>;

    async ok(){
        if(this.okCallback){
            await this.okCallback();
        }
        this.$emit('close');
    }

    copied: boolean = false;
    copy(){
        store.state.systemCopy(this.text);
        this.copied = true;
    }

}
